import React from 'react';
import { styled, Flex, CommonStyles } from '@teko/ds-desktop';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultPromotion = (_a) => {
  var _b = _a, {
    imageUrl,
    title,
    quantity,
    endAt,
    alt
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "title",
    "quantity",
    "endAt",
    "alt"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    align: "baseline"
  }), /* @__PURE__ */ React.createElement(ImageWrapper, null, /* @__PURE__ */ React.createElement("img", {
    src: imageUrl,
    alt,
    height: 25,
    width: 25
  })), /* @__PURE__ */ React.createElement(PromotionInfo, {
    style: { flex: 1 }
  }, /* @__PURE__ */ React.createElement(Title, null, title)));
};
const Wrapper = styled(Flex)((_c) => {
  var _d = _c, { theme } = _d, props = __objRest(_d, ["theme"]);
  return `${CommonStyles(__spreadValues({ theme }, props))};`;
});
const ImageWrapper = styled.div`
  padding: 0 0.25rem;
`;
const Title = styled.span`
  font-size: 0.875rem;
  white-space: pre-line;
`;
const PromotionInfo = styled.span`
  flex: 1;
  margin-left: 1rem;
`;

export { DefaultPromotion };
